import React from "react";

import { Assets } from "reducers/Assets";
import FilterHeader from "utils/columns/FilterHeader";
import { TYPES } from 'utils/constants';

import { buildAssetId } from 'utils/Assets';

import DateCell          from "../cells/DateColumn";
import EmptyDash         from "../cells/EmptyDash";
import TotalFileSizeCell from "../cells/TotalFileSizeColumn";
import VideoCell  		   from "../cells/VideoColumn";
import SelectCell        from "../cells/SelectCell";
import SelectAllAssetsCell from "../cells/SelectAllAssetsCell";
import AssetNameCell     from "../cells/AssetName";
import AssetActionsCell  from "../cells/AssetActions";
import { GRID_TYPE }     from '../constants';

function genRowId(data, str){
	return `${str}-${data}`;
}

export const ASSET_COLUMNS = [
	{
		...SelectCell,
		headerRenderer: () => {
			return (<SelectAllAssetsCell />);
		},
		getRowMetaData(data){
			return {
				type: TYPES.ASSETS,
				assetType: data.assetType,
				isSelected: data.isSelected || false,
				checkboxId: genRowId(data.id, TYPES.ASSETS),
				id: buildAssetId(data),
				shiftSelectConfig: {
					buildItemId: buildAssetId,
				},
			};
		},
		locked:false,
	},
	AssetNameCell,
	{
		key: "id",
		name: "ID",
		width:85,
		sortable:true,
		resizable:false,
	},
	AssetActionsCell,
	{
		key: "dimensions",
		name: "Dimensions",
		formatter:EmptyDash,
		width:120,
		resizable:false,
		sortable: true,
		filter:"Checkbox",
		headerRenderer: (
			<FilterHeader
				Reducer = {Assets}
				filterSelector = { state => state.assets.columnFilters.active.dimensions}
			/>
		),
	},
	{
		...TotalFileSizeCell,
		filter:"Range",
		headerRenderer: (
			<FilterHeader
				Reducer = {Assets}
				filterSelector = { state => state.assets.columnFilters.active.filesize}
			/>
		),
		getRowMetaData(data){
			return {
				type: GRID_TYPE.ASSET,
			};
		},
	},
	{
		...VideoCell,
		filter:"Checkbox",
		headerRenderer: (
			<FilterHeader
				Reducer = {Assets}
				filterSelector = { state => state.assets.columnFilters.active.encoded}
			/>
		),
	},
	{
		...DateCell,
		filter:"Date",
		key: "lastModified",
		name: "Last Modified",
		headerRenderer: (
			<FilterHeader
				Reducer = {Assets}
				filterSelector = { state => state.assets.columnFilters.active.lastModified }
			/>
		),
	},
];
